export default {"src":"__ASTRO_ASSET_IMAGE__NGe0VJi6__","width":14,"height":9,"format":"svg"}